import React from 'react'
import { graphql } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import Img from 'gatsby-image'
import 'prism-theme-night-owl'

import BlogHeader from '../styled/BlogHeader'
import BlogMeta from '../components/BlogMeta'
import Box from '../styled/Box'
import Cell from '../styled/Cell'
import FancyHeader from '../components/FancyHeader'
import Layout from '../components/Layout'
import Longform from '../styled/Longform'
import SEO from '../components/SEO'
import BlogShare from '../components/BlogShare'

function PostTemplate(props = {}) {
  const { mdx } = props.data
  const { frontmatter, body, timeToRead, fields } = mdx

  return (
    <Layout maxContentWidth="100%">
      <Cell>
        <SEO
          title={frontmatter.title}
          image={
            frontmatter.banner
              ? frontmatter.banner.childImageSharp.fluid.src
              : ''
          }
        />
        {frontmatter.banner && (
          <Box mb={{ _: 'xl', md: 'xxl' }}>
            <Box
              as={Img}
              fluid={frontmatter.banner.childImageSharp.fluid}
              borderRadius="base"
            />
          </Box>
        )}
        <BlogHeader>
          <Box as={FancyHeader} mb="l">
            <BlogHeader.Title>{frontmatter.title}</BlogHeader.Title>
          </Box>
          <BlogMeta frontmatter={frontmatter} timeToRead={timeToRead} />
        </BlogHeader>
        <Longform mb={{ _: 'xl', md: 'xxl' }}>
          <MDXRenderer>{body}</MDXRenderer>
        </Longform>
        <BlogShare path={`/blog${fields.slug}`} title={frontmatter.title} />
      </Cell>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      body
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        banner {
          childImageSharp {
            fluid(maxWidth: 750) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        tags
      }
      timeToRead
      fields {
        slug
      }
    }
  }
`

export default PostTemplate
